import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'vuetify/dist/vuetify.min.css'
import 'vuetify/src/styles/main.sass'
Vue.use(Vuetify)

const localStorageTheme = "theme-cache"

const opts = {
    icons: {
        iconfont: 'mdi', //'md' ||'fa' || 
    },
    theme: {
        options: {
            customProperties: true,
            themeCache: {
                get: key => localStorage.getItem(key),
                set: (key, value) => localStorage.setItem(localStorageTheme, value),
            },
        },
        themes: {
            light: {
                primary: '#01A1FD',
                secondary: '#585856',
                accent: '#01A1FD',
                error: '#e83131',
                warning: '#ffc107',
                info: '#009688',
                success: '#4caf50',
                background: '#ffffff'
            },
            dark: {
                primary: '#01A1FD',
                secondary: '#585856',
                accent: '#01A1FD',
                error: '#e83131',
                warning: '#ffc107',
                info: '#009688',
                success: '#4caf50',
                background: '#121212'
            }
        },
        dark: true
    },
}

export default new Vuetify(opts)
